import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function School(props: StickerArtProps) {
  return (
    <StickerFrame background="#2563eb" {...props}>
      <path d="M26 21 V17 A6 6 0 0 1 38 17 V21" fill="none" stroke="#ffffff" strokeWidth="3.5" />
      <rect x="17" y="20" width="30" height="32" rx="8" fill="#ffffff" />
      <path d="M17 30 Q32 36 47 30" fill="none" stroke="#1f2937" strokeWidth="2.5" />
      <rect x="24" y="38" width="16" height="9" rx="3" fill="#facc15" stroke="#1f2937" strokeWidth="2" />
    </StickerFrame>
  );
}
